export const randomID = (length: number, numbersOnly = false, chars = 'acdefhiklmnoqrstuvwxyz0123456789') => {
  var randomChars = (numbersOnly ? '0123456789' : chars).split('');
  var result = '';
  for (var i = 0; i < length; i++) {
    var x = Math.floor(Math.random() * randomChars.length);
    result += randomChars[x];
  }
  return result;
};
